import{c as p}from"./HeadingPanel-2044fcc5.js";import"react";import"prop-types";import"wix-rich-content-common";import"classnames";import"./constants.js";import"wix-rich-content-plugin-commons";const o={HEADINGS:"HEADINGS"},r={[o.HEADINGS]:p};export{o as Modals,r as ModalsMap};
//# sourceMappingURL=modals.js.map
